// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero Banner Container */
.hero-banner {
    position: relative;
    height: 70vh; /* Maintain a balanced height */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: var(--clr-white);
    font-family: var(--ff-primary);
    overflow: hidden;
    transition: background-image 0.5s ease-in-out; /* Smooth transition when changing banners */
}

/* Dark Overlay for Text Contrast */
.hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4); /* Dark overlay */
    z-index: 1;
}

/* Content Container */
.hero-content {
    position: relative;
    z-index: 2;
    max-width: var(--max-width);
    padding: 0 20px;
}

/* Hero Title Styles */
.hero-title {
    font-size: 2.8rem; 
    font-weight: 500; 
    margin-bottom: 1rem;
    line-height: 1.3;
    text-transform: capitalize; 
    letter-spacing: 1.5px; 
    color: var(--clr-white); 
    font-family: var(--ff-secondary); 
    opacity: 0;
    transform: translateY(50px);
    animation: slideIn 1s ease-out forwards 0.5s;
}

/* Subheadline Styles */
.hero-subtitle {
    font-size: 1.3rem; 
    margin-bottom: 2rem;
    font-weight: 400; 
    font-style: italic; 
    color: var(--clr-grey-9); 
    opacity: 0;
    transform: translateY(50px);
    animation: slideIn 1s ease-out forwards 1s;
}

/* Call-to-Action Button Styles */
.hero-cta {
    padding: 0.8rem 2rem;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--clr-white);
    background-color: var(--clr-primary-5);
    border: none;
    border-radius: 50px; /* Fully rounded button */
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
    opacity: 0;
    transform: translateY(50px);
    animation: slideIn 1s ease-out forwards 1.5s;
}

.hero-cta:hover {
    background-color: var(--clr-primary-7);
    transform: scale(1.05); /* Slight scaling effect on hover */
}

/* Slide-in Keyframe Animation */
@keyframes slideIn {
    0% {
        opacity: 0;
        transform: translateY(50px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Styles */
@media (max-width: 768px) {
    .hero-title {
        font-size: 2.5rem;
    }

    .hero-subtitle {
        font-size: 1.2rem;
    }

    .hero-cta {
        padding: 0.6rem 1.5rem;
        font-size: 1rem;
    }
}

/* Loading container */
.hero-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
}

/* Spinner animation */
.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
}

/* Loading text */
.loading-text {
    font-size: 1.2rem;
    font-weight: bold;
    color: var(--clr-white);
    opacity: 0.9;
}

/* Spinner animation keyframes */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Benefits Container */
.hero-benefits {
    list-style: none;
    padding: 0;
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 600px; /* Keeps it readable */
    margin-left: auto;
    margin-right: auto;
}

/* Individual Benefit Item */
.hero-benefits li {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--clr-grey-9);
    background: rgba(255, 255, 255, 0.15); 
    padding: 12px 18px;
    border-radius: 8px;
    width: 100%;
    max-width: 500px;
    transition: transform 0.3s ease-in-out, background 0.3s ease-in-out;
}

/* Benefit Icon */
.hero-benefits li::before {
    content: "✔️"; 
    font-size: 1.2rem;
    color: var(--clr-primary-5); 
}

/* Hover Effect */
.hero-benefits li:hover {
    transform: translateY(-3px);
    background: rgba(255, 255, 255, 0.25);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .hero-benefits {
        max-width: 90%;
    }

    .hero-benefits li {
        font-size: 1rem;
        padding: 10px 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/banner/HeroBanner.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;IAChB,6CAA6C,EAAE,4CAA4C;AAC/F;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,iBAAiB;IACjD,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;IAChC,UAAU;IACV,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;IACV,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,iCAAiC;AACjC;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,sCAAsC;IACtC,YAAY;IACZ,mBAAmB,EAAE,yBAAyB;IAC9C,eAAe;IACf,2DAA2D;IAC3D,UAAU;IACV,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,sCAAsC;IACtC,sBAAsB,EAAE,mCAAmC;AAC/D;;AAEA,gCAAgC;AAChC;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;AACJ;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,gCAAgC;AAChC;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB,EAAE,sBAAsB;IACxC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mEAAmE;AACvE;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA,2BAA2B;AAC3B;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":["/* Hero Banner Container */\n.hero-banner {\n    position: relative;\n    height: 70vh; /* Maintain a balanced height */\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    color: var(--clr-white);\n    font-family: var(--ff-primary);\n    overflow: hidden;\n    transition: background-image 0.5s ease-in-out; /* Smooth transition when changing banners */\n}\n\n/* Dark Overlay for Text Contrast */\n.hero-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4); /* Dark overlay */\n    z-index: 1;\n}\n\n/* Content Container */\n.hero-content {\n    position: relative;\n    z-index: 2;\n    max-width: var(--max-width);\n    padding: 0 20px;\n}\n\n/* Hero Title Styles */\n.hero-title {\n    font-size: 2.8rem; \n    font-weight: 500; \n    margin-bottom: 1rem;\n    line-height: 1.3;\n    text-transform: capitalize; \n    letter-spacing: 1.5px; \n    color: var(--clr-white); \n    font-family: var(--ff-secondary); \n    opacity: 0;\n    transform: translateY(50px);\n    animation: slideIn 1s ease-out forwards 0.5s;\n}\n\n/* Subheadline Styles */\n.hero-subtitle {\n    font-size: 1.3rem; \n    margin-bottom: 2rem;\n    font-weight: 400; \n    font-style: italic; \n    color: var(--clr-grey-9); \n    opacity: 0;\n    transform: translateY(50px);\n    animation: slideIn 1s ease-out forwards 1s;\n}\n\n/* Call-to-Action Button Styles */\n.hero-cta {\n    padding: 0.8rem 2rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: var(--clr-white);\n    background-color: var(--clr-primary-5);\n    border: none;\n    border-radius: 50px; /* Fully rounded button */\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.3s ease;\n    opacity: 0;\n    transform: translateY(50px);\n    animation: slideIn 1s ease-out forwards 1.5s;\n}\n\n.hero-cta:hover {\n    background-color: var(--clr-primary-7);\n    transform: scale(1.05); /* Slight scaling effect on hover */\n}\n\n/* Slide-in Keyframe Animation */\n@keyframes slideIn {\n    0% {\n        opacity: 0;\n        transform: translateY(50px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n    .hero-title {\n        font-size: 2.5rem;\n    }\n\n    .hero-subtitle {\n        font-size: 1.2rem;\n    }\n\n    .hero-cta {\n        padding: 0.6rem 1.5rem;\n        font-size: 1rem;\n    }\n}\n\n/* Loading container */\n.hero-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    text-align: center;\n}\n\n/* Spinner animation */\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(255, 255, 255, 0.3);\n    border-top: 4px solid white;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 10px;\n}\n\n/* Loading text */\n.loading-text {\n    font-size: 1.2rem;\n    font-weight: bold;\n    color: var(--clr-white);\n    opacity: 0.9;\n}\n\n/* Spinner animation keyframes */\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Benefits Container */\n.hero-benefits {\n    list-style: none;\n    padding: 0;\n    margin-top: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    max-width: 600px; /* Keeps it readable */\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* Individual Benefit Item */\n.hero-benefits li {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: var(--clr-grey-9);\n    background: rgba(255, 255, 255, 0.15); \n    padding: 12px 18px;\n    border-radius: 8px;\n    width: 100%;\n    max-width: 500px;\n    transition: transform 0.3s ease-in-out, background 0.3s ease-in-out;\n}\n\n/* Benefit Icon */\n.hero-benefits li::before {\n    content: \"✔️\"; \n    font-size: 1.2rem;\n    color: var(--clr-primary-5); \n}\n\n/* Hover Effect */\n.hero-benefits li:hover {\n    transform: translateY(-3px);\n    background: rgba(255, 255, 255, 0.25);\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n    .hero-benefits {\n        max-width: 90%;\n    }\n\n    .hero-benefits li {\n        font-size: 1rem;\n        padding: 10px 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
